export const blockIconsDevicePriceCheck = (
	<span className='material-symbols-outlined'>price_check</span>
);
